import React, { useEffect, useState } from "react";
import DateRange from "../dashboard/DateRange";
import { httpRequestGet, toaster } from "../../utils/utils";
import { useDispatch } from "react-redux";
import apiConstants from "../../constans/apiConstants";
import DataTable from "../../components/Table";

const CkycekycReport = ({ embedded = false }) => {
  const [data, setData] = useState([]);
  const [copyData, setcopyData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const value = [];
    data.forEach((item) => {
      value.push({
        ...item,
        ckycEkycFlag: !item.ckycEkycFlag,
      });
    });
    setcopyData(value);
  }, [data]);

  const applyDateRange = (startDate, endDate) => {
    const path = `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ckyc-ekyc/flag/data?${"fromDate=" + startDate + "&toDate=" + endDate}`;
    dispatch({ type: "LOADER_TRUE" });
    httpRequestGet(path)
      .then((res) => {
        dispatch({ type: "LOADER_FALSE" });
        if (res && res.data) {
          setData(res.data.body);
          toaster("success", res.data.message);
        }
      })
      .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
          toaster("error", err.data.message);
        }
      });
  };

  const content = (
    <>
      {embedded && (
        <h3 className="reports-tab-panel__title">EKYC / CKYC Details</h3>
      )}

      <div className="date-range">
        <DateRange applyDateRange={applyDateRange} />
      </div>

      {copyData.length > 0 && (
        <div className="proposal-dashboard__table-section">
          <DataTable
            cellHeaders={["Proposal No", "Journey", "Field Edited"]}
            data={copyData}
            keys={["proposalNumber", "selectedJourney", "ckycEkycFlag"]}
            fileName="ckyc_ekyc report"
            addSerialNo={true}
            convertValueToString={true}
            showExcelDownload={true}
            PerPageApiData={false}
            paginationItems={copyData}
            alwaysShown={false}
          />
        </div>
      )}
    </>
  );

  if (embedded) {
    return <div className="reports-tab-panel">{content}</div>;
  }

  return (
    <div className="proposal-dashboard ekyc-ckyc-report-page">
      <div className="proposal-dashboard__header ekyc-ckyc-report-page__header">
        <h2 className="proposal-dashboard__title">EKYC / CKYC Reports</h2>
        <p className="proposal-dashboard__subtitle">
          View proposal EKYC and CKYC flag changes for the selected date range
        </p>
      </div>

      <div className="reports-page__content">{content}</div>
    </div>
  );
};

export default CkycekycReport;
